import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

const pick = (items) => items[Math.floor(Math.random() * items.length)];

export function generateTask() {
  const first = pick([1, 2, 3, 4, 5]);
  const q = pick([2, 3]);
  const index = pick([2, 3, 4, 5]);
  const middle = first * q;
  return {
    type: "GeometricMiddleTermTask",
    data: { index, left: first, right: first * q * q, middle },
  };
}

export function renderTask({ data }) {
  return (
    <p>
      Trzy kolejne wyrazy dodatniego ciągu geometrycznego spełniają{" "}
      <InlineMath math={`a_{${data.index - 1}}=${data.left}`} /> oraz{" "}
      <InlineMath math={`a_{${data.index + 1}}=${data.right}`} />. Oblicz <InlineMath math={`a_${data.index}`} />.
    </p>
  );
}

export function renderInput({ data }, userAnswer, onChange, disabled) {
  return <FractionInput label={`a_${data.index}`} value={userAnswer} onChange={onChange} disabled={disabled} />;
}

export function checkAnswer({ data }, userAnswer) {
  return Number.isFinite(userAnswer?.parsed) && Math.abs(userAnswer.parsed - data.middle) < 0.01;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`a_${data.index}=${data.middle}`} />;
}

export function renderExplanation({ data }) {
  return (
    <div className="space-y-3">
      <p>Kwadrat środkowego wyrazu jest równy iloczynowi wyrazów sąsiednich.</p>
      <BlockMath math={String.raw`a_${data.index}^2=a_{${data.index - 1}}\cdot a_{${data.index + 1}}=${data.left}\cdot${data.right}`} />
      <BlockMath math={String.raw`a_${data.index}=\sqrt{${data.left * data.right}}=${data.middle}`} />
      <p>Wybieramy dodatni pierwiastek, ponieważ w treści podano, że wyrazy są dodatnie.</p>
    </div>
  );
}

export function renderUserAnswer(userAnswer, task) {
  if (!userAnswer?.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`a_${task?.data?.index ?? "n"}=${userAnswer.raw}`} />;
}
